import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class UmapGraph extends AbstractScatterVisualization {}
